function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M66.857 48.857V63l-34.714 5.143-13.5-1.929m48.214-24.428v-7.072l-34.714 5.143-27-3.857v28.286l6.75.964M59.324 58l2.275-.337M49.063 59.52l6.223-1.02M32.143 68.143V39.857M10.286 42.429V45M10.286 50.143v6.428",
  stroke: "#000",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M55.52 36.395l8.766-5.538L54 5.143H32.143L7.714 20.57l6.59 16.738M53.357 18l-1.928-5.143M56.05 24.084l-.838-2.038",
  stroke: "#000",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.714 20.571h21.857l1.84 4.644m5.518 13.932l-3.678-9.288",
  stroke: "#000",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.926 25.615l-2.076-5.044L42.267 5.143M29.571 20.571L54 5.143",
  stroke: "#000",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "/img/pending.svg";
export { SvgPending as ReactComponent };